import { render, staticRenderFns } from "./RequestStatusIcon.vue?vue&type=template&id=19f0f7c9&"
import script from "./RequestStatusIcon.vue?vue&type=script&lang=ts&"
export * from "./RequestStatusIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports